<div class="context-view">
  <div class="context-title">{{ 'MASTERDATA.DRIVER.LIST.TITLE' | translate }}</div>
  @if (!isLoading()) {
    <dx-data-grid
      id="driver-grid"
      [dataSource]="drivers()"
      [showRowLines]="true"
      [showColumnLines]="false"
      [showBorders]="true"
      [keyExpr]="'employeeNumber'"
      [allowColumnReordering]="false"
      [allowColumnResizing]="false"
      (onRowDblClick)="loadDriver($event)"
      style="width: 100%"
      height="100%">
      <dxo-scrolling
        mode="infinite"
        [useNative]="false"
        [scrollByContent]="true"
        [scrollByThumb]="true"
        showScrollbar="onHover">
      </dxo-scrolling>
      <dxo-search-panel [visible]="true" [highlightCaseSensitive]="false"> </dxo-search-panel>
      <dxo-selection mode="multiple" showCheckBoxesMode="none"></dxo-selection>
      <dxo-toolbar>
        <dxi-item name="searchPanel" location="before"></dxi-item>
      </dxo-toolbar>
      <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
      <dxi-column
        dataField="employeeNumber"
        [caption]="'MASTERDATA.DRIVER.DTO.ID' | translate"
        [allowSorting]="true"
        [calculateCellValue]="utilService.asString">
        <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
      </dxi-column>
      <dxi-column dataField="firstName" [caption]="'MASTERDATA.DRIVER.DTO.VORNAME' | translate" [allowSorting]="true">
      </dxi-column>
      <dxi-column dataField="lastName" [caption]="'MASTERDATA.DRIVER.DTO.NACHNAME' | translate" [allowSorting]="true">
      </dxi-column>
      <dxi-column
        dataField="drivingLicence"
        [caption]="'MASTERDATA.DRIVER.DTO.LICENSENUMBER' | translate"
        [allowSorting]="true"
        [calculateSortValue]="customLicenseSortValue"
        [calculateCellValue]="utilService.asStringTranslated('MASTERDATA.DRIVER.DTO.LICENSE_TYPE.')">
        <dxo-format type="fixedPoint" [precision]="0"> </dxo-format>
      </dxi-column>
      <dxi-column
        dataField="priority"
        caption="Priority"
        [caption]="'MASTERDATA.DRIVER.DTO.PRIO' | translate"
        [allowSorting]="true"
        [calculateSortValue]="customPrioritySortValue"
        [calculateCellValue]="utilService.asStringTranslated('MASTERDATA.DRIVER.DTO.PRIO_LEVEL.')">
        <dxo-format type="fixedPoint" [precision]="0"> </dxo-format>
      </dxi-column>
    </dx-data-grid>
  } @else {
    <app-loader></app-loader>
  }
</div>
